import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { ArrowBackIcon } from '@chakra-ui/icons'
import { Box, Button, Flex, FormControl, Heading, Image, Input, Stack, Text, useMediaQuery, VStack } from '@chakra-ui/react'
import SessionStartLogo from '../../components/SessionStartLogo'
import useAuth from '../../hooks/useAuth'
import clientAxios from '../../config/axios'

const quilmesImages = require.context('../../assets/images', true)

const ValidateEmail = () => {
  const { forgotPassword } = useAuth()
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [isLargerThan1280] = useMediaQuery('(min-width: 1367px)')
  const [email, setEmail] = useState('')
  const [errorEmail, setErrorEmail] = useState('')
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const handleSubmit = (e) => {
    const regexEmail = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/

    e.preventDefault()

    if (email === '') {
      setError('Es necesario que completes este campo.')

      return
    } else if (!regexEmail.test(email)) {
      setErrorEmail('El email no es válido')

      return
    } else {
      setErrorEmail('')
    }

    sessionStorage.setItem('email', email)

    clientAxios.post('/auth/sendPasswordResetEmail', { email })
      .then((res) => {
        navigate('/resend-email')
      })
      .catch((err) => {
        if (err.response.status === 400) {
          setErrorEmail('No existe ninguna cuenta registrada con ese correo electrónico. Verificá que esté bien escrito e intentalo de nuevo.')

          setTimeout(() => {
            setErrorEmail('')
          }, 3000)
        }
      })

    setError('')

    setTimeout(() => {
      setEmail('')
    }, 4000)
  }

  const deleteErrors = () => {
    setError('')
    setErrorEmail('')
  }

  return (
    <Box
      className='boxInvited'
      display={{ md: 'flex' }}
      justifyContent={'center'}
    >
      <Box bg='white' mx={'auto'}>
        <VStack
          alignItems={'flex-start'}
          as='form'
          autoComplete='off'
          padding={'3rem 1rem 2rem 1rem'}
          w={{ base: '100%', md: '100%' }}
          onSubmit={handleSubmit}
          {...(isLargerThan1280
            ? { paddingTop: '12rem' }
            : isLargerThan768
              ? { paddingTop: '3rem' }
              : {})}
        >
          <SessionStartLogo />
          <Link to={'/'}>
            <ArrowBackIcon color={'#0A0808'} h={6} marginTop={{ base: 6, md: 4 }} w={6} />
          </Link>
          <Heading fontSize={'1.5rem'} fontWeight={'400'} paddingTop={'2rem'}>
            Recuperar contraseña
          </Heading>
          <Text fontSize={'0.8rem'} fontWeight={'400'}>
            Ingresá el correo electrónico que usas para iniciar sesión.
          </Text>

          <Stack paddingTop={'2rem'} w={{ base: '100%', md: 400 }}>

            <FormControl className='floating-label-group'>
              <Input
                className='input'
                id='email'
                name='email'
                placeholder=' '
                type='text'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => deleteErrors()}
                {...(error !== '' ? { borderColor: 'red.500' } : errorEmail !== '' ? { borderColor: 'red.500' } : {})}
                _hover={{
                  ...(error !== '' ? { borderColor: 'red.500' } : errorEmail !== '' ? { borderColor: 'red.500' } : {})
                }}
              />
              <label
                className='placeholder'
                htmlFor='email'
                {...(error
                  ? { className: 'error-input' }
                  : errorEmail
                    ? { className: 'error-input' }
                    : {})}
              >
                Correo electrónico *
              </label>
            </FormControl>
            {errorEmail && (
              <Text color='red.500' fontSize={'12px'} w={{ base: '75%', md: '100%' }}>
                {errorEmail}
              </Text>
            )}

          </Stack>

          {error && (
            <Text color='red.500' fontSize={'12px'} w={{ base: '75%', md: 300 }}>
              Es necesario que completes este campo.
            </Text>
          )}

          <Stack
            justifyContent='center'
            paddingTop={3}
            w={{ base: '100%', md: 400 }}
          >
            <Button
              _focusVisible={{ outline: 'none' }}
              type='submit'
              variant={'btn-quilmes'}
            >
              Continuar
            </Button>
          </Stack>
        </VStack>

      </Box>
      <Box
        alignItems={'center'}
        bgColor={'#F7F7F7'}
        justifyContent={'center'}
        w={'50%'}
        {...(isLargerThan768
          ? { margin: '0', height: '100vh' }
          : { margin: '0 auto', height: 'auto' })}
      >
        {isLargerThan768
          ? (
            <Image
              alt='logo'
              h={'auto'}
              margin={0}
              mx={'auto'}
              objectFit='cover'
              padding={0}
              paddingTop={'2.5rem'}
              src={quilmesImages('./ilustracion.svg')}
              w={{ md: '50%' }}
            />
          )
          : null}
      </Box>
    </Box>
  )
}

export default ValidateEmail
